var _circle, _circle2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBotModalCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "white",
    fillOpacity: 0.04
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23.5,
    stroke: "white",
    strokeOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5792 16.4216L17.2634 30.7374",
    stroke: "white",
    strokeWidth: 2.33626,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2633 16.4216L31.5791 30.7374",
    stroke: "white",
    strokeWidth: 2.33626,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotModalCancel);
export default __webpack_public_path__ + "static/media/bot-modal-cancel.fd2e8e8efa92c9f4c3749e5ff7cb3ff2.svg";
export { ForwardRef as ReactComponent };